import { BaseGetYearGroupListService } from "../../../base/services/BaseGetYearGroupListService";
import { IGetListService } from "../../../abstractions/services/actions/IGetListService";
import { createCachedFactory } from "../../../utils/factoryUtils";
import { AplicacionResponse } from "../response/AplicacionResponse";
import { fx_createAplicacionGrpcService } from "./AplicacionGrpcService";

/** Servicio que retorna las aplicaciones de una finca agrupadas por año (años
 *  descendente, items descendente por fecha). Se apoya en el list service plano
 *  de la finca, así que hereda su sync delta e invalidaciones de cache. */
class AplicacionGetYearGroupListByFincaIdService extends BaseGetYearGroupListService<AplicacionResponse> {
  /** @param _fincaId Finca cuyas aplicaciones se agrupan por año. */
  constructor(private readonly _fincaId: string) {
    super();
  }

  /** Servicio de lista plana subyacente, scoped por finca. */
  protected get listService(): IGetListService<AplicacionResponse> {
    return fx_createAplicacionGrpcService(this._fincaId);
  }

  /** Agrupa por el año de la fecha de aplicación. */
  protected getFecha(item: AplicacionResponse): string {
    return item.fechaAplicacion;
  }
}

/** Factory cacheada: retorna una única instancia del servicio por fincaId. */
export const fx_createAplicacionGetYearGroupListByFincaIdService =
  createCachedFactory(
    (fincaId) => new AplicacionGetYearGroupListByFincaIdService(fincaId),
  );
